<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :editIcon="editIcon"
    :readOnly="readOnly"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :isTextButton="isTextButton"
    :textButton="textButton"
  >

    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        id="printableELement"
        :readOnly="readOnly"
        @installment-update="loadServerEntry(entry.id)"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>    
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint
  },
  created() {
    // console.log("edit sale  ordercreated");
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SALE_LOT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.saleLotViewIndexFilter;          
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    updateServerEntry: function(saleOrder) {
      // console.log("saleOrder", saleOrder, saleOrder.validations, this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_SALE_ORDER_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateSaleOrder.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry)
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
      this.$emit("entry-canceled");
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_SALE_LOT_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      saleLotViewIndexFilter(id: $id) {
        id
        clientName
        saleDate
        saleLotId
        saleLot
        cropLot
        originalLot
      }
    }
  }
`;

</script>

<style scoped></style>
